import React, { useEffect, useRef, useState } from 'react';
import { CommentDesign, Contest, ContestTag, DesignContest, DesignDetails, Keyword, User } from '../../../global';
import useSWR, { mutate } from 'swr';
import axiosHelper from '../../../helpers/axiosHelper';
import { fullPathLogo } from '../../../helpers/utils';
import { ReactImageGalleryItem } from 'react-image-gallery';
import designDefaultLogo from '../../../assets/Private-Design.png';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faXTwitter, faPinterest } from '@fortawesome/free-brands-svg-icons';
import { faMedal, faCompress, faHeart, faExpand, faFileArrowDown, faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

import { Navigation } from 'swiper/modules';
import FadeInOut from '../../FadeInOut/FadeInOut';
import PopUpDeleteDraft from '../../PopUp/PopUpDeleteDraft/PopUpDeleteDraft';
import PopUpPublishDraft from '../../PopUp/PopUpEditDraft/PopUpPublishDraft';
import PopUpErrorUploadDesign from '../../PopUp/PopUpErrorUploadDesign/PopUpErrorUploadDesign';
import PopUpInappropriate from '../../PopUp/PopUpInappropriate/PopUpInappropriate';
import PopUpShare from '../../PopUp/PopUpShare/PopUpShare';
import { DesignCommentMaker, DesignComment } from '../DesignComment/DesignComment';
import { DesignUserCardWLF } from '../DesignUserCard/DesignUserCardWLF';
import { useNavigate } from 'react-router-dom';
import styles from './DesignComponent.module.scss';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { DesignPager } from '../DesignPager/DesignPager';
import { computeContestPhase, hasCommunityVote } from '../../../helpers/contestUtilities';
import UploadComponent from '../UploadComponent/UploadComponent';
import ContestSidePart from '../../../routes/contest/ContestSidePart';
import { useAuth } from '../../../context/AuthContext';
import LogoAnimation from '../../LogoAnimation/LogoAnimation';
import ContestCardWLF from '../../Contest/ContestCard/ContestCardWLF';
import { useBanner } from '../../../context/BannerContext';

//USED IN GalleryWLF and ProfileMain
interface Props {
  designName?: string;
  userNameForURL?: string;
  loggedUser: User | null;
  contest?: Contest;
  designNames?: string[];
}

const DesignComponent: React.FC<Props> = ({ designName, loggedUser, contest, designNames, userNameForURL }) => {
  const { isDesignLiked, toggleDesignLiked, showLoginPopup } = useAuth();
  const { createAndAddBannerMessage } = useBanner();

  const { data: designData, error: designFetchError } = useSWR('designname|' + designName, axiosHelper.designFetcher);
  const {
    data: contestData,
    error: contestFetchError,
    mutate: mutateContest,
  } = useSWR(designData && !contest ? 'contestname|' + designData.contest.nameForURL : null, axiosHelper.contestsFetcher);
  const [design, setDesign] = useState<DesignDetails>();
  const [actualContest, setActualContest] = useState<Contest>();
  const [popUpDeleteDraft, setPopUpDeleteDraft] = useState(false);
  const [popUpPublishDraft, setPopUpPublishDraft] = useState(false);
  const [popUpErrorUploadDesign, setPopUpErrorUploadDesign] = useState(false);
  const [designImages, setDesignImages] = useState<ReactImageGalleryItem[]>([]);
  const [bigGallery, setBigGallery] = useState(false);
  const [commentsVisible, setCommentsVisible] = useState(false);
  const [hasAwards, setHasAwards] = useState(0);
  const [activeIndex, setActiveIndex] = useState<any>(0);
  const swiperNavPrevRef = useRef(null);
  const swiperNavNextRef = useRef(null);
  const [popupShare, setPopupShare] = useState(false);
  const [popupInappropriate, setPopupInappropriate] = useState(false);
  const [voted, setVoted] = useState(false);

  const redirect = useNavigate();
  const [daysLeft, setDaysLeft] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [prevDesignName, setPrevDesignName] = useState<string>();
  const [nextDesignName, setNextDesignName] = useState<string>();

  useEffect(() => {
    if (designNames && designName) {
      const index = designNames.indexOf(designName);
      if (index > 0) {
        setPrevDesignName(designNames[index - 1]);
      } else {
        setPrevDesignName(undefined);
      }
      if (index < designNames.length - 1) {
        setNextDesignName(designNames[index + 1]);
      } else {
        setNextDesignName(undefined);
      }
    } else {
      setPrevDesignName(undefined);
      setNextDesignName(undefined);
    }
  }, [designNames, designName]);

  useEffect(() => {
    if (contest) {
      console.log('contest passed');
      setActualContest(contest);
    }
    if (contestData) {
      console.log('contest data fetched');
      setActualContest(contestData);
    }
  }, [contestData, contest]);

  useEffect(() => {
    console.log('contest fetch error');
    console.log(contestFetchError);
  }, [contestFetchError]);

  useEffect(() => {
    console.log('design fetch error');
    console.log(designFetchError);
    if (designFetchError) {
      createAndAddBannerMessage('Access denied', 'error', 'access-denied' + designName);
    }
  }, [designFetchError]);

  const goToEditDraft = async () => {
    setEditMode(true);
  };

  const deleteDesign = async () => {
    if (loggedUser?.userType === 'G' && design) {
      await axiosHelper
        .deleteDesign(design.id)
        .then((response) => {
          redirect(`/${ROUTEPATHS.CONTEST}/${design.contest.nameForURL}/${ROUTEPATHS.CONTEST_GALLERY}`);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    console.log('design data use effect');
    if (designData) {
      console.log(designData);
      setDesign(designData);
    }
  }, [designData]);

  const mutateCallback = (newDesign: DesignDetails) => {
    mutate('designname|' + designName, newDesign, { revalidate: false });
    setDesign(newDesign);
  };
  const commentCallback = (newDesign: DesignDetails) => {
    mutateCallback(newDesign);
    setCommentsVisible(true);
  };
  const deleteCallback = (newDesign: DesignDetails) => {
    mutateCallback(newDesign);
  };
  const replyCallback = (newDesign: DesignDetails) => {
    mutateCallback(newDesign);
  };
  const flagCallback = (newDesign: DesignDetails) => {
    createAndAddBannerMessage('Flag successful', 'success');
    window.scrollTo(0, 0);
  };
  const inappropriateCallback = (n: number) => {
    if (n === 1) {
      createAndAddBannerMessage('Flag successful', 'success');
    } else {
      createAndAddBannerMessage('Flag failed', 'error');
    }
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    function fillImagesArray(design: DesignDetails) {
      console.log('FILL IMAGES ARRAY');
      let array: ReactImageGalleryItem[] = [];
      if (design.image1Attachment) {
        array.push({
          original: fullPathLogo(design.image1Attachment.s3Path),
          thumbnail: fullPathLogo(design.image1Attachment.s3Path),
        });
      } else {
        array.push({
          original: designDefaultLogo,
          thumbnail: designDefaultLogo,
        });
      }
      if (design.image2Attachment) {
        array.push({
          original: fullPathLogo(design.image2Attachment.s3Path),
          thumbnail: fullPathLogo(design.image2Attachment.s3Path),
        });
      }
      if (design.image3Attachment) {
        array.push({
          original: fullPathLogo(design.image3Attachment.s3Path),
          thumbnail: fullPathLogo(design.image3Attachment.s3Path),
        });
      }
      if (design.image4Attachment) {
        array.push({
          original: fullPathLogo(design.image4Attachment.s3Path),
          thumbnail: fullPathLogo(design.image4Attachment.s3Path),
        });
      }
      if (design.image5Attachment) {
        array.push({
          original: fullPathLogo(design.image5Attachment.s3Path),
          thumbnail: fullPathLogo(design.image5Attachment.s3Path),
        });
      }
      setDesignImages(array);
    }
    if (design) {
      fillImagesArray(design);
    }
  }, [design]);

const flagPressed = () => {
  if (loggedUser) {
  setPopupInappropriate(true);
  } else {
    showLoginPopup();
  }
};

  const voteDesign = () => {
    console.log('vote design');
    if (design && loggedUser) {
      axiosHelper.voteDesign(design.id).then((response) => {
        console.log(response);
        setDesign(response);
      });
    } else {
      showLoginPopup();
    }
  };

  const canPublishDraft = () => {
    console.log('can publish draft');
    if (design) {
      if (design.contest.contestType.name === 'Naming') {
        if (design.payoff && design.name) {
          setPopUpPublishDraft(true);
        } else {
          setPopUpErrorUploadDesign(true);
        }
      } else {
        if (design.name && design.textAbstract && design.image1Attachment && design.image1Attachment.s3Path && design.tags.length > 0 && design.agreement) {
          setPopUpPublishDraft(true);
        } else {
          setPopUpErrorUploadDesign(true);
        }
      }
    }
  };

  const downloadArchive = () => {
    console.log('download archive');
    if (design?.archiveAttachment.s3Path) {
      const element = document.createElement('a');
      element.href = `${design?.archiveAttachment.s3Path}`;
      element.target = '_self';
      element.click();
    }
  };

  const downloadVideo = () => {
    console.log('download video');
    if (design?.videoAttachment.s3Path) {
      const element = document.createElement('a');
      element.href = `${design?.videoAttachment.s3Path}`;
      element.target = '_self';
      element.click();
    }
  };
  const isCommunityVotePhase = (contest: DesignContest) => {
    const phase = computeContestPhase(contest);
    return phase === 'community-vote';
  };

  if (!design) return <LogoAnimation />;
  if (editMode) {
    if (actualContest) {
      return (
        <div className="bg-light-gray ">
          <main className={`container pt-5 mb-5 px-sm-0  overflow-hidden `}>
            <div className="row ">
              <ContestSidePart
                contest={actualContest}
                disableUpload={true}
                setPopupMessage={() => {
                  console.log('SET POPUP MESSAGE');
                }}
              />
              <div className="col-12 col-md-9 pt-5  px-5 px-sm-0">
                <UploadComponent contest={actualContest} design={design} setPopupMessage={(val) => console.log(val)} mutateCallback={mutateCallback} />
              </div>
            </div>
          </main>
        </div>
      );
    }
  }
  return (
    <main className={`${styles.designWrapper} container  mt-5 px-3 overflow-hidden`}>
      <div className="d-flex flex-row justify-content-end mb-5  ">
        {!design.isTemporary && <DesignPager prevName={prevDesignName} nextName={nextDesignName} userNameForURL={userNameForURL} contestNameForURL={contest?.nameForURL} />}
      </div>
      <div className="row ">
        {/* <HorizontalSection> */}

        <div className="pe-lg-3">
          {bigGallery ? (
            <FadeInOut show={bigGallery} duration={500}>
              <div className="row  mb-7 d-sm-none d-lg-block">
                <div className=" ">
                  <Swiper
                    modules={[Navigation]}
                    navigation={{
                      prevEl: swiperNavPrevRef.current,
                      nextEl: swiperNavNextRef.current,
                    }}
                    effect="cards"
                    slidesPerView={1}
                    // speed={800}
                    loop={false}
                    onActiveIndexChange={(swiper: any) => setActiveIndex(swiper.activeIndex)}
                    className={`${styles.mybigswiper}`}
                  >
                    {designImages.map((item: any, index: number) => (
                      <SwiperSlide key={index} className={`${styles.swiperslide} `}>
                        {activeIndex != null ? (
                          <>
                            {hasAwards > 0 ? (
                              <div className={`${styles.swiperTrophy} `}>
                                <FontAwesomeIcon icon={faMedal as IconProp} className={` ${styles.trophyDiv}`}></FontAwesomeIcon>
                              </div>
                            ) : null}
                            <img src={designImages[activeIndex].original} alt="" />
                            <div className={`${styles.swiperNavNext} bg-blue `} onClick={() => setBigGallery(!bigGallery)}>
                              <FontAwesomeIcon icon={faCompress as IconProp} className="color-light" style={{ fontSize: '20px' }}></FontAwesomeIcon>
                            </div>
                          </>
                        ) : (
                          <>
                            {hasAwards > 0 ? (
                              <div className={`${styles.swiperTrophy} `}>
                                <FontAwesomeIcon icon={faMedal as IconProp} style={{ height: '30px', width: '30px' }} className="btn-green rounded full"></FontAwesomeIcon>
                              </div>
                            ) : null}
                            <img src={item.original} alt="" />
                            <div className={`${styles.swiperNavNext} bg-blue`} onClick={() => setBigGallery(!bigGallery)}>
                              <FontAwesomeIcon icon={faCompress as IconProp} className="color-light" style={{ fontSize: '20px' }}></FontAwesomeIcon>
                            </div>
                          </>
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                <div className={`d-flex  ${designImages.length < 5 ? 'justify-content-start' : 'justify-content-between '} mt-5 `}>
                  {designImages.length > 0 ? (
                    designImages.map((item: any, index: number) => (
                      <div
                        className={` ${designImages.length < 5 ? 'me-5' : ' '} ${styles.thumbnaildivBig}  `}
                        key={index}
                        onClick={() => {
                          setActiveIndex(index);
                        }}
                      >
                        <img src={item.original} alt="" className={` ${styles.thumbnailimg}  ${activeIndex !== index && styles.border}`} />
                      </div>
                    ))
                  ) : (
                    <div className="d-flex flex-row justify-content-between  w-100">
                      <div className={`${styles.thumbnaildivBig}`}> </div>
                      <div className={`${styles.thumbnaildivBig}`}> </div>
                      <div className={`${styles.thumbnaildivBig}`}> </div>
                      <div className={`${styles.thumbnaildivBig}`}> </div>
                      <div className={`${styles.thumbnaildivBig}`}> </div>
                    </div>
                  )}
                </div>
              </div>
            </FadeInOut>
          ) : null}
        </div>
        {/* </HorizontalSection> */}

        <div className={`col-12 col-md-12 col-lg-3 `}>
          <div className="row ">
            <div className="col-12   d-flex flex-column align-items-center justify-content-center ">
              {/* Vote section */}
              {hasCommunityVote(design.contest) && (
                <>
                  <div className=" d-flex flex-column align-items-center justify-content-center w-100 bg-light mb-4" style={{ borderRadius: '8px', height: '220px' }}>
                    <div className="  d-flex flex-column align-items-center justify-content-center w-100" style={{ height: '110px' }}>
                      <span className="sub-title-brief color-blue mt-4 mb-3">{design.votesCount} votes</span>
                      <span className={`text-16 `}>{daysLeft} days to vote</span>
                    </div>
                    {!voted && (
                      <div className=" w-100  d-flex flex-row align-items-center justify-content-center" style={{ height: '110px' }}>
                        <button
                          disabled={!isCommunityVotePhase(design.contest)}
                          className={`${
                            isCommunityVotePhase(design.contest) ? `btn-success` : `btn-dark_grey_70_disabled`
                          } rounded col-10 mt-5 d-flex flex-row align-items-center mb-4 justify-content-center`}
                          style={{ height: '50px' }}
                          onClick={() => (voted ? null : voteDesign())}
                        >
                          <div className="col-1 ">
                            <FontAwesomeIcon icon={faHeart as IconProp} style={{ fontSize: '2.8rem' }} />
                          </div>
                          <span className="col-11 ">{isCommunityVotePhase(design.contest) ? 'vote' : 'coming soon'}</span>
                        </button>
                      </div>
                    )}
                    {voted && (
                      <div className="d-flex  flex-column align-items-center justify-content-center   h-50 w-100">
                        <FontAwesomeIcon icon={faHeart as IconProp} className="color-success " style={{ fontSize: '5.5rem' }} />
                        <span className="text-16 fw-bold color-success">VOTED!</span>
                      </div>
                    )}
                  </div>
                </>
              )}
              <div>
                {contest ? (
                  <DesignUserCardWLF design={design} />
                ) : (
                  <>
                    <ContestCardWLF wrap={false} contest={actualContest!} />
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row buttons">
            {design?.isTemporary === false && (
              <div className="col-12">
                {(loggedUser?.userType === 'G' || loggedUser?.id === design?.contest.client.id) && (
                  <button className={`btn-danger rounded full mt-7 mb-3`} onClick={() => deleteDesign()}>
                    delete design
                  </button>
                )}
                {/* {!contest?.isPrivate && communityVote(design?.contest.endVotingDate) && !voted && (
              <button className={`btn-success rounded full mt-7 mb-3`} onClick={() => voteDesign()}>
                Vote
              </button>
            )}
            {!contest?.isPrivate && communityVote(design?.contest.endVotingDate) && voted && (
              <button className={`btn-danger rounded full mt-7 mb-3`} onClick={() => removeVote()}>
                remove vote
              </button>
            )} */}
                <button
                  className={`btn-warning rounded full ${loggedUser?.userType === 'G' || !contest?.isPrivate ? 'mt-3' : 'mt-7'} mb-3`}
                  onClick={() => flagPressed()}
                >
                  flag as inappropriate
                </button>
                {popupInappropriate && <PopUpInappropriate onInappropriate={inappropriateCallback} popup={popupInappropriate} close={() => setPopupInappropriate(false)} />}
                {!isDesignLiked(design) && (
                  <button className="btn-blue rounded full  mb-3" onClick={() => toggleDesignLiked(design)}>
                    Add to favorites
                  </button>
                )}
                {isDesignLiked(design) && (
                  <button className="btn-danger rounded full mb-3" onClick={() => toggleDesignLiked(design)}>
                    Remove from favorites
                  </button>
                )}

                <button className="btn-blue rounded  full mb-3" onClick={() => setPopupShare(true)}>
                  share design
                </button>
                {popupShare && <PopUpShare popup={popupShare} shortUrl={window.location.href} close={() => setPopupShare(false)} />}
              </div>
            )}
            {design?.isTemporary === true && loggedUser && loggedUser?.id === design.designer.id && (
              <div className="col-12">
                <button className="btn-blue rounded full mt-7 mb-3" onClick={() => goToEditDraft()}>
                  Edit draft
                </button>
                <button className="btn-success rounded full mb-3" onClick={() => canPublishDraft()}>
                  Publish Design
                </button>
                <button className="btn-red rounded  full mb-3" onClick={() => (setPopUpDeleteDraft(true), console.log(popUpDeleteDraft))}>
                  Delete Draft
                </button>
                {/* <button className="btn-blue rounded big full mb-3">
              <div className="d-flex col-12 flex-row align-items-center justify-content-center">
                <div className="col-1 justify-content-start d-flex ">
                  <FontAwesomeIcon
                    icon={faEnvelope as IconProp}
                    className={`${styles.trophyDiv}`}
                  ></FontAwesomeIcon>
                </div>
                <span className="col-11">Request Revision</span>
              </div>
            </button> */}
              </div>
            )}
          </div>
          <PopUpPublishDraft design={design} loggedUser={loggedUser} popup={popUpPublishDraft} close={() => setPopUpPublishDraft(false)} />
          <PopUpErrorUploadDesign popup={popUpErrorUploadDesign} close={() => setPopUpErrorUploadDesign(false)} editCallback={goToEditDraft} />
          <PopUpDeleteDraft design={design} loggedUser={loggedUser} popup={popUpDeleteDraft} close={() => setPopUpDeleteDraft(false)} />
          <div className="tags mt-7  d-flex flex-wrap">
            {design.keywords && design.keywords.length > 0 ? (
              <>
                {design.keywords.map((item: Keyword, index: number) => (
                  <button key={index} className="btn-tag mb-4 px-0 me-5 ">
                    <span>{item.name}</span>
                  </button>
                ))}
              </>
            ) : (
              <>
                {design?.tags &&
                  design.tags.map((item: ContestTag, index: number) => (
                    <button key={index} className="btn-tag mb-4 me-4">
                      <span>{item.name}</span>
                    </button>
                  ))}
              </>
            )}
          </div>
          <div className="col-12 col-md-6 mt-7  position-relative">
            <a href={`https://www.facebook.com/sharer/sharer.php?u=https://desall.com/contest/${design?.contest?.nameForURL}/gallery/${design?.nameForURL}`} target="_blank">
              <button className="btn-social__facebook full rounded mb-3 ">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faFacebookF as IconProp} className="text color-light" />
                </div>
                <span className="text-lowercase">like</span>
              </button>
            </a>
          </div>
          <div className="col-12 col-md-6   position-relative">
            <a
              href={`http://twitter.com/share?hashtags=desallcom&text=${design?.name} by ${design?.dslUser?.username}. Check it out on Desall.&url=https://desall.com/contest/${design?.contest?.nameForURL}/gallery/${design?.nameForURL}&via=desallcom`}
              target="_blank"
            >
              <button className="btn-social__twitter full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faXTwitter as IconProp} className="text color-light" />
                  {/* <img src={xLogo} className="" style={{ height: '15px', width: '15px' }} /> */}
                </div>
                <span className="text-lowercase">post</span>
              </button>
            </a>
          </div>
          <div className="col-12 col-md-6   position-relative">
            <a
              href={`http://pinterest.com/pin/create/button/?url=desall.com/contest/${contest?.nameForURL}/Gallery/${design?.nameForURL}&media=${design?.image1Attachment?.s3Path}&description=${design?.dslUser?.username} on Desall.Check it out on Desall.`}
              target="_blank"
            >
              <button className="btn-social__pinterest full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faPinterest as IconProp} className="text color-light" />
                </div>
                <span className="text-lowercase">save</span>
              </button>
            </a>
          </div>
        </div>

        <div className={`col-12 col-sm-12 col-md-12 col-lg-9 ps-lg-5 pe-lg-3 `}>
          {bigGallery === false && design.contest.contestType.name !== 'Naming' ? (
            <FadeInOut show={!bigGallery} duration={500}>
              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: swiperNavPrevRef.current,
                  nextEl: swiperNavNextRef.current,
                }}
                effect="cards"
                slidesPerView={1}
                // speed={800}
                loop={false}
                onActiveIndexChange={(swiper: any) => setActiveIndex(swiper.activeIndex)}
                className={`${styles.myswiper} `}
              >
                {designImages.map((item: any, index: number) => (
                  <div key={index}>
                    <SwiperSlide className={`${styles.swiperslide} `}>
                      {activeIndex != null ? (
                        <>
                          {hasAwards > 0 ? (
                            <div className={`${styles.swiperTrophy} `}>
                              <FontAwesomeIcon icon={faMedal as IconProp} className={`${styles.trophyDiv}`}></FontAwesomeIcon>
                            </div>
                          ) : null}
                          <img src={designImages && designImages[activeIndex].original} alt="" />
                          <div className={`${styles.swiperNavNext} bg-blue d-sm-none d-lg-flex`} onClick={() => setBigGallery(!bigGallery)}>
                            <FontAwesomeIcon icon={faExpand as IconProp} className="color-light" style={{ fontSize: '18px' }}></FontAwesomeIcon>
                          </div>

                          {/* <div className={` ${styles.nextButtonContainer}`}>
                          <div className={` ${styles.nextButton}`} onClick={() => nextImage()}></div>
                        </div>
                        <div className={` ${styles.prevButtonContainer}`}>
                          <div className={` ${styles.prevButton}`} onClick={() => prevImage()}></div>
                        </div> */}
                        </>
                      ) : (
                        <>
                          {hasAwards > 0 ? (
                            <div className={`${styles.swiperTrophy} `}>
                              <FontAwesomeIcon icon={faMedal as IconProp} className={`${styles.trophyDiv}`}></FontAwesomeIcon>
                            </div>
                          ) : null}
                          <img src={item.original} alt="" />
                          <div className={`${styles.swiperNavNext} bg-blue`} onClick={() => setBigGallery(!bigGallery)}>
                            <FontAwesomeIcon icon={faExpand as IconProp} className="color-light" style={{ fontSize: '20px' }}></FontAwesomeIcon>
                          </div>
                        </>
                      )}
                    </SwiperSlide>
                  </div>
                ))}
              </Swiper>
            </FadeInOut>
          ) : null}
          {bigGallery === false && design.contest.contestType.name !== 'Naming' ? (
            <div className={` d-flex flex-row ${designImages.length < 5 ? 'justify-content-start' : 'justify-content-between '} mt-5 mb-7`}>
              {designImages.length > 0 ? (
                designImages.map((item: any, index: number) => (
                  <div
                    className={` ${designImages.length < 5 ? 'me-5' : ' '} ${styles.thumbnaildiv}  `}
                    key={index}
                    onClick={() => {
                      setActiveIndex(index);
                    }}
                  >
                    <img alt="" src={item.original} className={` ${styles.thumbnailimg}  ${activeIndex !== index && styles.border}`} />
                  </div>
                ))
              ) : (
                <div className="d-flex flex-row justify-content-between  w-100">
                  <div className={`${styles.thumbnaildiv}`}> </div>
                  <div className={`${styles.thumbnaildiv}`}> </div>
                  <div className={`${styles.thumbnaildiv}`}> </div>
                  <div className={`${styles.thumbnaildiv}`}> </div>
                  <div className={`${styles.thumbnaildiv}`}> </div>
                </div>
              )}
            </div>
          ) : null}
          {design?.contest.contestType.name === 'Naming' && (
            <>
              <div className="row mb-5 ">
                <div className="col-12 col-md-3 fw-bold  ">Name</div>
                <div className="col-12 col-md-9  ">
                  <span className="light-title">{design.name} </span>
                </div>
              </div>
              <div className="row mb-5">
                <div className="col-12 col-md-3 fw-bold  ">Payoff</div>
                <div className="col-12 col-md-9  ">
                  <span className="bigger-text-bold"> {design.payoff}</span>{' '}
                </div>
              </div>
            </>
          )}

          <div className="row mb-5  ">
            {design?.archiveAttachment || design?.videoAttachment ? <div className="col-12 col-sm-12 col-md-3 fw-bold mb-3 ">Attachments</div> : null}
            {design?.archiveAttachment ? (
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 me-4">
                <button className="btn-dark-blue-materials full mb-4 rounded" onClick={downloadArchive} disabled={design?.archiveAttachment ? false : true}>
                  <div className="btn-icon">
                    <FontAwesomeIcon icon={faFileArrowDown as IconProp} style={{ fontSize: '1.75rem' }} className="text color-light" />
                  </div>
                  <div>ARCHIVE (.zip)</div>
                </button>
              </div>
            ) : null}
            {design?.videoAttachment ? (
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 ms-md-3">
                <button className="btn-dark-blue-materials full mb-4 rounded" onClick={downloadVideo} disabled={design?.videoAttachment ? false : true}>
                  <div className="btn-icon">
                    <FontAwesomeIcon icon={faFileArrowDown as IconProp} style={{ fontSize: '1.75rem' }} className="text color-light" />
                  </div>
                  <div>ARCHIVE VIDEO (.zip)</div>
                </button>
              </div>
            ) : null}
          </div>
          <div className="row mb-5">
            <div className="col-12 col-md-3 fw-bold  ">Abstract</div>
            <div className="col-12 col-md-9  "> {design?.textAbstract ? design.textAbstract : '-'} </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-md-3 fw-bold  ">Description</div>
            <div className="col-12 col-md-9 mb-5 ">{design?.textDescription ? design.textDescription : '-'}</div>
          </div>
          {design?.isTemporary === false && (
            <div className="row mb-2 ">
              <div className="col-2 col-md-1 "> </div>
              <div className="col-10 col-md-10  ps-5 fw-bold d-flex flex-row align-items-center">
                This design has {design.mainCommentsOrdered.length} comment{design.mainCommentsOrdered.length !== 1 ? 's' : ''} &nbsp; &nbsp;&nbsp;&nbsp;
                {design &&
                  design.mainCommentsOrdered.length > 0 &&
                  (commentsVisible ? (
                    <span className="color-blue d-flex flex-row align-items-center cursor-pointer " onClick={() => setCommentsVisible(false)}>
                      <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faAngleUp as IconProp} className="text color-blue  " />
                      &nbsp; hide
                    </span>
                  ) : (
                    <span className="color-blue d-flex flex-row align-items-center cursor-pointer" onClick={() => setCommentsVisible(true)}>
                      <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faAngleDown as IconProp} className="text color-blue" />
                      &nbsp; show
                    </span>
                  ))}
              </div>
            </div>
          )}
          {design?.isTemporary === false && (
            <div>
              <DesignCommentMaker design={design} mutateCallback={commentCallback} />
            </div>
          )}
          {commentsVisible && (
            <div className="mb-5">
              {design.mainCommentsOrdered.map((aComment: CommentDesign, index: number) => (
                <DesignComment comment={aComment} key={index} design={design} replyCallback={replyCallback} deleteCallback={deleteCallback} flagCallback={flagCallback} />
              ))}
            </div>
          )}
        </div>

        {/* {design?.contest.contestType.name === 'Naming' && (
          <div className={`col-12 col-sm-12 col-md-12 col-lg-9 ps-lg-5 pe-lg-3 `}>
            <div className="row mb-5 ">
              <div className="col-12 col-md-3 fw-bold  ">Naming</div>
              <div className="col-12 col-md-9  ">
                <span className="light-title">{design?.name} </span>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-12 col-md-3 fw-bold  ">Payoff</div>
              <div className="col-12 col-md-9  ">
                <span className="bigger-text-bold"> {design?.payoff}</span>{' '}
              </div>
            </div>

            <div className="row mb-5">
              {design?.archiveAttachment || design?.videoAttachment ? <div className="col-12 col-sm-12 col-md-3 fw-bold mb-3 ">Attachments</div> : null}
              {design?.archiveAttachment ? (
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 me-4">
                  <button className="btn-dark-blue-materials full mb-4 rounded" onClick={downloadArchive} disabled={design?.archiveAttachment ? false : true}>
                    <div className="btn-icon">
                      <FontAwesomeIcon icon={faFileArrowDown as IconProp} style={{ fontSize: '1.75rem' }} className="text color-light" />
                    </div>
                    <div>ARCHIVE (.zip)</div>
                  </button>
                </div>
              ) : null}
              {design?.videoAttachment ? (
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 ms-md-3">
                  <button className="btn-dark-blue-materials full mb-4 rounded" onClick={downloadVideo} disabled={design?.videoAttachment ? false : true}>
                    <div className="btn-icon">
                      <FontAwesomeIcon icon={faFileArrowDown as IconProp} style={{ fontSize: '1.75rem' }} className="text color-light" />
                    </div>
                    <div>ARCHIVE VIDEO(.zip)</div>
                  </button>
                </div>
              ) : null}
            </div>
            <div className="row mb-5">
              <div className="col-12 col-md-3 fw-bold  ">Description</div>
              <div className="col-12 col-md-9  "> {design?.textDescription} </div>
            </div>
            {design?.textAbstract && (
              <div className="row mb-5">
                <div className="col-12 col-md-3 fw-bold  ">Abstract</div>
                <div className="col-12 col-md-9  "> {design?.textAbstract} </div>
              </div>
            )}
            <div className="row mb-2">
              <div className="col-2 col-md-1 "> </div>
              <div className="col-10 col-md-10  ps-5 fw-bold  d-flex flex-row align-items-center ">
                This design has {design?.mainCommentsOrdered ? design?.mainCommentsOrdered.length : 0} comments &nbsp; &nbsp;&nbsp;&nbsp;
                {visibility === 1 && design.mainCommentsOrdered.length > 0
                  ? design.mainCommentsOrdered.length > 0 && (
                      <span className="color-blue  d-flex flex-row align-items-center cursor-pointer" onClick={() => setVisibility(0)}>
                        <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faAngleUp as IconProp} className="text color-blue " />
                        &nbsp; hide
                      </span>
                    )
                  : design.mainCommentsOrdered.length > 0 && (
                      <span className="color-blue d-flex flex-row align-items-center cursor-pointer" onClick={() => setVisibility(1)}>
                        <FontAwesomeIcon style={{ fontSize: '1.5rem' }} icon={faAngleDown as IconProp} className="text color-blue" />
                        &nbsp; show
                      </span>
                    )}
              </div>
            </div>
            <DesignCommentMaker design={design} mutateCallback={mutateCallback} />
            {visibility === 1
              ? design?.mainCommentsOrdered
                ? design.mainCommentsOrdered.map((aComment: CommentDesign, index: number) => (
                    <DesignComment
                      delete={(deleted) => (setDeleteCommentBanner(deleted), window.scrollTo(0, 0))}
                      flag={(flag) => (createAndAddBannerMessage('Flag successful', 'success'), window.scrollTo(0, 0))}
                      comment={aComment}
                      design={design}
                      mutateCallback={mutateCallback}
                      key={index}
                    />
                  ))
                : ''
              : ''}
          </div>
        )} */}
      </div>
    </main>
  );
};

export default DesignComponent;
